import { render } from "./PaymentMethod.vue?vue&type=template&id=52f4ee12&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&scoped=true&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&scoped=true&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=52f4ee12&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f4ee12"]])

export default __exports__